<template>
  <section class="content">
    <div class="row" style="justify-content: end;">
      <div class="form-group col-auto col-sm-auto">
        <button type="button" class="btn btn-primary" style="flex: 1; display: flex;" @click="scanQR()">
          <i class="fi fi-rr-add mr-2" style="padding-top: 2px;"></i> Tambah Nomor WhatsApp
        </button>
      </div>
      <div class="form-group col-auto col-sm-auto" style="padding-right: 10px;">
        <button type="button" class="btn btn-block btn-outline-primary" style="flex: 1; display: flex;" @click="tutorial()">
          Tutorial
        </button>
      </div>
    </div>
    <div class="card card-primary">
      <div class="card-body">
        <h4>
          <button v-if="statusTutorial" type="button" class="btn" @click="statusTutorial = false">
            <i class="fas fa-arrow-left"></i>
          </button>
          <span class="bd-content-title">{{statusTutorial == false ? 'Status Koneksi WhatsApp' : 'Tutorial Koneksi WhatsApp'}}</span>
        </h4>
        <div style="border-bottom: 2px solid #D9D9D9; padding-top: 20px;"></div>
        <div style="padding-top: 20px;">
          <div v-if="statusTutorial == false" class="row">
            <div class="form-group col-auto col-sm-auto">
              <img :src="require(`../assets/img/whatsapp.png`)"  style="max-width: 100%; max-height: 110px;">
            </div>
            <div class="form-group col-auto col-sm-auto" style="display: flex; align-items: center;">
              <div>
                <h6>
                  <span class="text-xs bd-content-title">Pastikan WhatsApp Anda tetap terhubung</span>
                </h6>
                <span class="text-xs">Koneksi akan otomatis terputus jika Aplikasi WhatsApp di smartphone kamu tidak aktif lebih dari 14 hari</span>
              </div>
            </div>
          </div>
          <div v-else class="row" style="display: flex; justify-content: center; align-items: center;">
            <div class="form-group col-auto col-sm-auto px-0 px-sm-5">
              <div>
                <h6>
                  <span class="text-xs bd-content-title">Tutorial menghubungkan WhatsApp dengan bosCOD</span>
                </h6>
                <div class="text-xs">1. Buka whatsapp di smartphone kamu</div>
                <div class="text-xs">2. Klik menu <i class="fi fi-rr-menu-dots-vertical" style="color: grey;"></i> atau settings <i class="fi fi-rr-settings" style="color: grey;"></i> dan klik linked devices</div>
                <div class="text-xs">3. Klik Link a Device</div>
                <div class="text-xs">4. Arahkan kamera smartphone kamu ke kode QR berikut</div>
              </div>
            </div>
            <div class="form-group col-auto col-sm-auto">
              <div id="qr_code" v-bind:class="{ 'skeleton-item': loading }" style="width: 200px; height: 200px;">
                <img v-if="qr_code != ''" :src="qr_code" alt="QR Code" style="width: 200px; height: 200px;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" ref="scanQR" data-backdrop="static">
      <WhatsAppQRScan ref="waQR" @tutorialClicked="tutorial()" @afterScan="afterScan()" @rescan="scanQR()" />
    </div>
    <div class="modal fade" ref="historyModal" tabindex="-1" role="dialog" aria-hidden="true">
      <WhatsAppHistory ref="whatsappHistory" />
    </div>
    <div class="modal fade" ref="limitModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-body">
						<img src="../assets/img/limit.svg" class="d-block m-auto" />
						<br />
						<h5 style="text-align: center;">
							Batas maksimal 5 perangkat. Hapus salah satu perangkat yang terhubung untuk menambahkan yang baru.
						</h5>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary w-100" data-dismiss="modal">Mengerti</button>
					</div>
				</div>
			</div>
    </div>
    <div class="modal fade" ref="removeModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-body">
						<img src="../assets/img/warning.svg" class="d-block m-auto" />
						<br />
						<h5 style="text-align: center;">
							Yakin ingin menghapus perangkat ini?
						</h5>
            <p style="text-align: center;">
							Pastikan lokasi yang dipilih sudah benar karna perubahan hanya bisa dilakukan oleh tim CS.
						</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-primarys w-50" data-dismiss="modal">Batalkan</button>
						<button type="button" class="btn btn-primary w-50" @click="removeDevice">Hapus</button>
					</div>
				</div>
			</div>
    </div>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3">
      <div v-for="(device, index) in deviceList" :key="index" class="col-md-4 col-sm-6 col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h5 v-if="device.editing === true" class="card-title d-flex align-items-center">
                  <input type="text" v-model="device.device_name" class="form-control" @keyup.enter="saveDeviceName(device)" />
                  <button class="btn" disabled>
                    <i class="fi fi-rr-edit"></i>
                  </button>
                  <button class="btn btn-outline-primary btn-sm ml-2" @click="saveDeviceName(device)">
                    Simpan
                  </button>
                </h5>
                <h5 v-else class="card-title d-flex align-items-center">
                  {{ device.device_name }}
                  <button class="btn" @click="editDeviceName(device)">
                    <i class="fi fi-rr-edit"></i>
                  </button>
                </h5>
              </div>
              <button class="btn text-danger" @click="showRemoveModal(device)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
            <p class="card-text d-flex align-items-center">
              <img src="../assets/img/whatsapp.svg" alt="whatsapp" style="margin-right: 8px;">
              {{ device.phone }}
            </p>
            <div v-if="device.status === 1" class="badge badge-success">Connected</div>
            <div v-else class="badge badge-danger">Disconnected</div>
            <hr>
            <div class="row d-flex align-items-center">
              <div class="col-1">
                <i class="fas fa-paper-plane"></i>
              </div>
              <div class="col-11">
                Jumlah Pesan Terkirim<br>
                <b>{{ device.message_count }}</b>
              </div>
            </div>
            <hr>
            <!-- <div class="row d-flex align-items-center">
              <div class="col-1">
                <i class="fas fa-headset"></i>
              </div>
              <div class="col-11">
                CS Terhubung<br>
                <b>{{ device.cs_name }}</b>
              </div>
            </div>
            <hr> -->
            <div class="row d-flex align-items-center">
              <div class="col-1">
                <i class="fas fa-user-lock"></i>
              </div>
              <div class="col-11">
                Safe Limiter<br>
                <b>{{ device.message_count_today }} / {{ device.limit_message }} chat</b>
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-between w-100">
              <button class="btn btn-outline-primary flex-fill mx-1" @click="goToSetting(device)">Setting</button>
              <button class="btn btn-primary flex-fill mx-1" @click="showHistory(device)">Riwayat</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import $ from 'jquery';
import Swal from "sweetalert2";
import { authFetch } from "@/libs/hxcore";
import WhatsAppHistory from '../dialog/WhatsAppHistory.vue';
import WhatsAppQRScan from '../dialog/WhatsAppQRScan.vue';
import WhatsAppSetting from './WhatsAppSetting.vue';

export default {
  name: 'WhatsApp',
  components: {
    WhatsAppSetting,
    WhatsAppHistory,
    WhatsAppQRScan
  },
  data() {
    return {
      method: '',
      customSwal: {},
      formTitle: 'Whatsapp',
      statusTutorial : false,
      showHistoryModal: false,
      loading: true,
      deviceList: [],
      selectedDevice: null
    }
  },
  methods: {
    async loadDeviceList() {
      const response = await authFetch('/whatsapp/notification_device');
      const json = await response.json();

      this.deviceList = json?.data ?? [];
    },
    tutorial() {
      this.statusTutorial = true;
      $(this.$refs.scanQR).modal("hide");

      if (this.$refs.waQR.qr_code == '') {
        this.$refs.waQR.getQRCode();
      }
    },
    afterScan() {
      $(this.$refs.scanQR).modal("hide");
      setTimeout(() => {
        this.loadDeviceList();
      }, 10000);
    },
    scanQR() {
      if (this.deviceList.length >= 5) {
        $(this.$refs.limitModal).modal('show');
        return;
      }

      $(this.$refs.scanQR).modal("show");

      if (this.$refs.waQR.qr_code == '') {
        this.$refs.waQR.phone = null;
        this.$refs.waQR.getQRCode();
      }
    },
    getImage(fileName) {
      return require(`../assets/img/${fileName}.png`); // the module request
    },
    showRemoveModal(device) {
      this.selectedDevice = device;
      $(this.$refs.removeModal).modal('show');
    },
    async removeDevice() {
      const item = { deleted_at: new Date().toISOString().slice(0, 19).replace('T', ' ') };
      const response = await authFetch(`/whatsapp/notification_device/${this.selectedDevice.id}`, {
      method: 'PUT',
      body: Object.keys(item).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(item[key])).join('&')
      });
      const json = await response.json();

      if (json?.success) {
      $(this.$refs.removeModal).modal('hide');

      await this.loadDeviceList();
      }
    },
    goToSetting(device) {
      this.$router.push({ path: `/settings/whatsapp/${device.id}`, params: { device } });
    },
    showHistory(device) {
      this.selectedDevice = device;
      this.showHistoryModal = true;
      $(this.$refs.historyModal).modal('show');
      this.$refs.whatsappHistory.phone = device?.phone;
      this.$refs.whatsappHistory.refresh();
    },
    editDeviceName(device) {
      this.$set(device, 'editing', true);
    },
    async saveDeviceName(device) {
      const item = { device_name: device.device_name };
      const response = await authFetch(`/whatsapp/notification_device/${device.id}`, {
        method: 'PUT',
        body: Object.keys(item).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(item[key])).join('&')
      });
      const json = await response.json();
      this.$set(device, 'editing', false);

      if (json?.success) {
        await this.loadDeviceList();
      }
    }
  },
  mounted() {
    this.customSwal = Swal.mixin({
      customClass: {
        popup: 'w-fit',
        title: 'h4 tex-dark',
        actions: 'd-flex justify-content-between flex-row-reverse',
        confirmButton: 'btn btn-primary btn-block font-weight-bold py-3',
        denyButton: 'btn btn-outline-primary w-49 font-weight-bold py-3',
        cancelButton: 'btn btn-primary btn-block font-weight-bold py-3',
      },
      buttonsStyling: false
    });

    $('.loading-overlay').removeClass('show');
    $(this.$refs.historyModal).modal({ show: false });
    this.loadDeviceList();
  }
}
</script>

<style scoped>
.text-xs {
  margin-bottom: 10px;
  font-size: 1rem !important;
}

.modal-dialog {
  max-width: 800px;
  margin: 1.75rem auto;
}
</style>